import Common from '../common'
var Js = Common('productdetail')
export default {
	name: 'productdetail',
	mixins: [Js],
	components: {},
	data() {
		return {

			searchItem: {},
			optionData: {
				labelOptions: [],
				skuOptions: [],
				statusOptions: [{
					text: '启用',
					value: 1
				}, {
					text: '禁用',
					value: -1
				}],
			},
			otherData: {},
			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			},

			type: 0, //0添加 1修改
			data: {
				role: 9,
				title: '',
				price: 0,
				stock: 0, //展示库存
				sale_count: 0, //销量
				listorder: 0, //排序
				mainImg: [],
				content: '',
				bannerImg: [],
				img_array: [],
				shop_no: '',
				category_id: null,
			},
			shopOptions: [],
			labelOptions: [
				{description:'爆款',relation_one:0}
			]

		}

	},

	mounted() {
		const self = this;
		self.table_arguments.tree_props = {
			children: 'child',
			child: 'child',
			hasChildren: 'child'
		}
		console.log('this.$route.params', this.$route.params)
		self.type = this.$route.params.type;
		this.init()
	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	methods: {

		/**
		 * 初始化
		 */
		init() {
			const self = this;
			if (self.type === 0) {
				this.initShopData();
			} else {
				self.searchItem.product_no = this.$route.params.product_no;
				this.initMainData();
			}
		},

		//上传图片
		imageChange(e) {
			const self = this;
			self.data.mainImg = e.value;
			console.log('self.data', self.data)
		},

		imageChange2(e) {
			const self = this;
			self.data.bannerImg = e.value;
			console.log('self.data', self.data)
		},

		imageChange3(e) {
			const self = this;
			self.data.img_array = e.value;
			console.log('self.data', self.data)
		},

		shopChange(e) {
			const self = this;
			self.shopOptions.forEach((item,index)=>{
				if(item.user_no == e){
					self.labelOptions = item.relation;
				}
			})
		},

		//添加商品
		async addProduct() {

			const self = this;
			const postData = {};
			postData.saveAfter = [
				{
					tableName:'ProductDate',
					FuncName:'add',
					data:{
						res:{
							product_no:'product_no'
						},
						type:1,
						is_template:0,
						stock:self.data.stock
					}
				}
			]
			postData.token = self.$store.getters.getToken;
			postData.data = self.$$cloneForm(self.data);

			var res = await self.$$api_productAdd({
				data: postData
			});
			if (res.solely_code == 100000) {
				this.$message({
					message: '添加成功',
					type: 'success'
				});
				self.data = {
					title: '',
					price: 0,
					stock: 0, //库存
					sale_count: 0, //销量
					listorder: 0, //排序
					mainImg: [],
					content: '',
					bannerImg: [],
					img_array: [],
					shop_no: '',
					category_id: null
				}
			}
		},
		
		//修改信息
		async updateProduct() {
		
			const self = this;
			const postData = {};
			postData.token = self.$store.getters.getToken;
			postData.data = self.$$cloneForm(self.data);
			postData.searchItem = {
				id:self.mainData.id
			}
			var res = await self.$$api_productUpdate({
				data: postData
			});
			if (res.solely_code == 100000) {
				this.$message({
					message: '修改成功',
					type: 'success'
				});
			}
		},


		//获取类别
		async initShopData(type) {
			const self = this;
			const postData = {};
			postData.getBefore = {
				user: {
					tableName: 'User',
					middleKey: 'user_no',
					key: 'user_no',
					condition: 'in',
					searchItem: {
						user_type: ['in', [1]],
						behavior: ['in', [0]]
					}
				}
			}
			postData.getAfter = {
				relation: {
					tableName: 'Relation',
					middleKey: 'user_no',
					key: 'relation_two',
					condition: '='
				}
			}
			postData.token = self.$store.getters.getToken;

			try {
				var res = await self.$$api_userInfoGet({
					data: postData
				});
			} catch (err) {
				console.log(err);
				self.$notify('网络故障', 'error');
			};

			if (res) {
				self.shopOptions = res.info.data;
				if(type){
					self.shopOptions.forEach((item,index)=>{
						if(item.user_no == self.mainData.shop_no){
							self.labelOptions.push.apply(self.labelOptions,item.relation);
						}
					})
				}
			};
			console.log('self.shopOptions', self.shopOptions)
		},


		/**
		 * 列表主函数
		 */
		async initMainData(isNew) {

			const self = this;
			const postData = {};
			postData.token = self.$store.getters.getToken;
			if (self.searchItem) {
				postData.searchItem = self.$$cloneForm(self.searchItem)
			};
			if (JSON.stringify(self.getBefore) != "{}") {
				postData.getBefore = self.$$cloneForm(self.getBefore);
			};

			var res = await self.$$api_productGet({
				data: postData
			});
			self.mainData = res.info.data[0];
			self.initShopData(true);
			
			self.data.title = self.mainData.title;
			self.data.price = self.mainData.price;
			self.data.stock = self.mainData.stock;
			self.data.sale_count = self.mainData.sale_count;
			self.data.listorder = self.mainData.listorder;
			self.data.mainImg = self.mainData.mainImg;
			self.data.content = self.mainData.content;
			self.data.bannerImg = self.mainData.bannerImg;
			self.data.img_array = self.mainData.img_array;
			self.data.shop_no = self.mainData.shop_no;
			self.data.category_id = self.mainData.category_id;
			console.log('mainData',self.data)
		},

	},


}



// WEBPACK FOOTER //
// ./src/views/detail/productdetail.js